/* eslint-disable no-await-in-loop */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import {
  Box,
  makeStyles,
  useMediaQuery,
  Button,
  withStyles,
  Typography,
} from "@material-ui/core";
import { useHistory, useRouteMatch } from "react-router-dom";
import { primaryColor } from "resources/constants";
import { useDispatch, useSelector } from "react-redux";
import { useEffectAsync } from "lib/react/customHooks";
import athenaClient from "lib/axios/clients";
import CircularProgress from "@material-ui/core/CircularProgress";
import buildRequestUrl from "lib/requests/requestUtils";
import {
  changeSelectedScenarioAsyncAction,
  addScenarioTotalsAsyncAction,
} from "app/scenarios/duck/actions";
import {
  getScenarioEstimations,
  getScenarioEstimationsByDate,
  getScenarioEstimationsDaily,
} from "lib/requests/scenarios";
import CardComponent from "app/common/CardComponent";
import { readString, jsonToCSV } from "react-papaparse";
import _ from "lodash";
import { fetchCatalogInfo } from "lib/requests/catalog";
import { setTask, removeTask } from "app/common/task/duck/slices";
import getStatus, {
  PollingTimeoutError,
  getStatusWithoutPolling,
} from "lib/requests/status";
import { downloadBlob } from "lib/utils";
import { useSnackbar } from "notistack";
import { getPathnameByCycletype, isCycleTypeById } from "lib/utils/cycles";
import TaskProgressSnackbar from "app/common/task/TaskProgressSnackbar";
import SnackbarActionButtons from "app/common/snackbar/SnackbarActionButtons";
import withExportScenario from "app/common/scenario/withExportScenario";
import mixpanelTrack from "app/common/MixpanelComponent";
import moment from "moment";
import ScaleLoader from "react-spinners/ScaleLoader";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },

  inputContainer: {
    display: "flex",
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "#EEEEEE",
    marginTop: "10px",
    marginBottom: "15px",
  },
  buttonContainer: {
    display: "flex",
    marginTop: "5px",
    marginBottom: "5px",
  },
  endButton: {
    flex: 1,
    display: "flex",
    justifyContent: "end",
  },
  endButtonInput: {
    flex: 1,
    display: "flex",
    justifyContent: "end",
    marginRight: "2px",
  },
  startButton: {
    flex: 1,
    display: "flex",
    justifyContent: "start",
  },
  startText: {
    flex: 1,
    display: "flex",
    justifyContent: "start",
    marginLeft: "10px",
    alignItems: "center",
  },
  disabledButton: {
    "&:disabled": {
      backgroundColor: "#E8BDBB",
      color: "white",
    },
  },
  spinnerParent: {
    "&>span>span": {
      display: "flex",
    },
  },
  fileName: {
    fontSize: "16px",
    fontFamily: "Lato",
  },
  circularProgress: {
    color: "white",
  },
}));

const ImportScenarioCard = ({
  estimations,
  scenarioName,
  setDataError,
  setDataDescriptionError,
  scenarioId,
  dialogClose,
  cycleData,
}) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("450"));
  const dispatch = useDispatch();
  const history = useHistory();
  const { url } = useRouteMatch();
  const classes = useStyles();
  const [csvFile, setCsvFile] = useState({});
  const [isSelectedCsv, setIsSelectedCsv] = useState(true);
  const [scenarioEstimations, setScenarioEstimations] = useState(estimations);
  const [catalogForDataload, setCatalogForDataload] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const cycleSlice = useSelector((state) => state.cycle);
  const scenariosSlice = useSelector((state) => state.scenarios);
  const catalogSlice = useSelector((state) => state.catalog);
  const retailersSlice = useSelector((state) => state.retailers);
  const areaSlice = useSelector((state) => state.areas);
  const [fileNameValue, setFileNameValue] = useState("");
  const fileInput = React.useRef();
  const [arePendingTasks, setArePendingTasks] = React.useState(false);
  const scenarioDataToImport = {
    name: scenarioName,
    id: scenarioId,
    cycle: {
      label: cycleData.label,
      cycle_type_id: cycleData.cycle_type_id,
    },
  };
  const cycleType = isCycleTypeById(
    scenarioDataToImport.cycle.cycle_type_id,
    cycleSlice
  );
  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };
  const checkTradePromotionAnnual = () => {
    return (
      isCycleTypeById(scenarioDataToImport.cycle.cycle_type_id, cycleSlice) ===
      "Pricing 2.0"
    );
  };
  const checkDailyTradePromotions = () => {
    return (
      isCycleTypeById(scenarioDataToImport.cycle.cycle_type_id, cycleSlice) ===
      "Daily Trade Promotions"
    );
  };
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    /* MIXPANEL TRACKS */
    mixpanelTrack("Import csv section visited");
    /* END OF MIXPANEL TRACKS */
  }, []);

  useEffectAsync(
    async () => {
      if (!estimations) {
        if (checkDailyTradePromotions()) {
          return getScenarioEstimationsDaily({
            filters: {
              scenario: { id: scenarioId },
              group_by: ["product_id", "area_id", "retailer_id"],
            },
          });
        }
        if (checkTradePromotionAnnual()) {
          return getScenarioEstimationsByDate({
            filters: {
              scenario: { id: scenarioId },
              group_by: ["product_id", "area_id", "retailer_id"],
            },
          });
        }
        return getScenarioEstimations({
          filters: {
            scenario: { id: scenarioId },
          },
        });
      }
      return estimations;
    },
    (result) => {
      setScenarioEstimations(
        _.keyBy(
          result,
          (estimation) =>
            `${estimation.product_id}-${estimation.area_id}-${estimation.retailer_id}`
        )
      );
    },
    []
  );

  useEffectAsync(
    async () => {
      let catalogData = {};
      if (
        scenariosSlice.totalsByScenarioId[scenarioId].delivery_id !==
        scenariosSlice.selectedScenario.delivery_id
      ) {
        catalogData = await fetchCatalogInfo();

        return catalogData;
      }
      return catalogData;
    },
    (result) => {
      setCatalogForDataload(result);
    },
    []
  );

  const preventPageUnload = (e) => {
    e.preventDefault();
    e.returnValue = "";
  };

  useEffect(() => {
    if (arePendingTasks)
      window.addEventListener("beforeunload", preventPageUnload);
    else window.removeEventListener("beforeunload", preventPageUnload);
    return () => {
      window.removeEventListener("beforeunload", preventPageUnload);
    };
  }, [arePendingTasks]);

  const buttonWithBehavior = (withFunction, scenario, template) =>
    withFunction(
      (p) => (
        <StyledButton
          autoFocus
          variant="outlined"
          disableRipple
          onClick={(e) => {
            e.stopPropagation();
            p.onClick(e);
          }}
          style={{
            textTransform: "none",
            fontSize: "15px",
            color: "black",
            backgroundColor: "white",
            paddingTop: "3px",
            paddingBottom: "3px",
          }}
        >
          Download template
        </StyledButton>
      ),
      scenario,
      template
    );

  const ButtonWithExportTemplate = buttonWithBehavior(
    withExportScenario,
    scenarioDataToImport,
    "template"
  );

  const enqueueErrorSnackbar = (key) => {
    if (key) closeSnackbar(key);
    enqueueSnackbar(
      `Error when update prices from '${scenarioName}'. Try again shortly`,
      {
        variant: "error",
      }
    );
    setArePendingTasks(false);
  };

  const enqueueLoadingSnackbar = (action) =>
    enqueueSnackbar(
      `Importing prices to Scenario ${scenarioName} (${scenariosSlice.totalsByScenarioId[scenarioId].scenario.cycle.label})`,
      {
        persist: true,
        action,
      }
    );

  const enqueueTimeoutSnackbar = (onAction, snackbarKey) => {
    if (snackbarKey) closeSnackbar(snackbarKey);
    enqueueSnackbar(
      `Could not update the status of the task. Note that if you dismiss this message, 
                    the task can still be completed, but you will not get notified`,
      {
        variant: "warning",
        persist: "true",
        action: (key) => (
          <SnackbarActionButtons
            action="Reconnect"
            onAction={onAction}
            key={key}
            onDismiss={() => setArePendingTasks(false)}
          />
        ),
      }
    );
  };

  const enqueueSuccessSnackbar = (onAction, snackbarKey) => {
    if (snackbarKey) closeSnackbar(snackbarKey);
    enqueueSnackbar(
      `Prices successfully imported to Scenario ${scenarioName} (${scenariosSlice.totalsByScenarioId[scenarioId].scenario.cycle.label})`,
      {
        variant: "success",
        persist: "true",
        action: (key) => (
          <SnackbarActionButtons
            action="Go to Scenario"
            onAction={onAction}
            key={key}
          />
        ),
      }
    );
  };

  const StyledButton = withStyles(() => ({
    label: {
      padding: isSmallScreen ? "0px 0px 0px 0px" : "0px 5px 0px 5px",
    },
  }))(Button);

  const StyledButtonBrowse = withStyles(() => ({
    label: {
      padding: isSmallScreen ? "0px 0px 0px 0px" : "0px 15px 0px 15px",
    },
  }))(Button);

  const StyledButtonImport = withStyles(() => ({
    label: {
      padding: isSmallScreen ? "0px 5px 0px 5px" : "0px 20px 0px 20px",
    },
  }))(Button);

  const updatePriceScenario = async (data) => {
    const config = {
      method: "POST",
      url: buildRequestUrl({}, "scenarios/importPricesCSV"),
      data,
    };

    const response = await athenaClient(config);

    return response.data.task;
  };

  const trackCSVButton = () => {
    /* MIXPANEL TRACKS */
    mixpanelTrack(`Import Prices CSV applied`);
    /* END OF MIXPANEL TRACKS */
  };

  const importCSV = async (data) => {
    let snackbarKey;
    const dataError = {
      data: null,
      description: null,
    };
    setIsLoading(true);
    try {
      // Check if the file is a CSV

      if (
        !(
          csvFile.type === "text/csv" ||
          csvFile.type === "application/vnd.ms-excel"
        )
      ) {
        dataError.data = "Invalid file type";
        dataError.description = `"${fileNameValue}" file is not a valid CSV file`;
        throw dataError;
      }

      // Store the data as string
      if (typeof data === "object") {
        const csvFileData = new FileReader();
        csvFileData.onloadend = (evt) => {
          const content = evt.target.result;
          importCSV(content);
        };
        csvFileData.readAsText(csvFile);
        return;
      }

      const firstLine = data.trim().split("\n")[0];
      if (!firstLine.includes(",")) {
        dataError.data = "Invalid file type";
        dataError.description = `"${fileNameValue}" file is not comma separated, you need to save your file with comma as delimiter`;
        throw dataError;
      }

      // CSV string to JSON
      const dataJSON = readString(data.trim(), {
        delimiter: ",",
        header: true,
      });

      // Check for errors when converting the file
      if (dataJSON.errors.length !== 0) {
        const error = dataJSON.errors[0];
        dataError.data = `[Row ${error.row + 2}] ${error.message}`;
        dataError.description = JSON.stringify(dataJSON.data[error.row]);
        throw dataError;
      }

      // Check that all headers are present
      const refHeaders = [
        "Product Id",
        "Product UPC",
        "Product",
        "Retailer",
        "Retailer Id",
        "Area",
        "Area Id",
        "Line",
        "Category",
        "Price",
      ];

      if (checkTradePromotionAnnual()) refHeaders.push("Date");
      if (checkDailyTradePromotions()) refHeaders.push("Date", "Event");

      refHeaders.forEach((ref) => {
        const found = dataJSON.meta.fields.find((header) => header === ref);
        if (!found) {
          dataError.data = `Missing required field '${ref}' in .csv file. Download the template to match the required format`;
          dataError.description = `The required fields are: ${refHeaders.join(
            "; "
          )}`;
          throw dataError;
        }
      });

      // Check that Product-Retailer-Area exists
      let line = 1;
      // Send dataJson to athena
      const formatDataJSON = [];
      const checkDuplicatedKeys = {};
      const scenariosEstimationsMap = new Map();
      Object.keys(scenarioEstimations).map((value) =>
        scenariosEstimationsMap.set(value, value)
      );

      dataJSON.data.forEach((element, index) => {
        const throwNumberError = (column, elem) => {
          dataError.data = `The following Column ID from .csv file is not valid. Please convert it to an Integer Number and try again:`;
          dataError.description = (
            <div>
              <div>{`Row: ${line}`}</div>
              <div>{`Column: ${column}`}</div>
              <div>{`Id: ${elem}`}</div>
            </div>
          );
          throw dataError;
        };

        // Helper function to normalize IDs and check for errors
        const normalizeId = (column, value) => {
          const numValue = Number(value);
          if (Number.isNaN(numValue)) throwNumberError(column, value);
          return numValue.toFixed(0);
        };

        // Normalize ids to fixed 0, so we don't have decimals
        const ids = {
          productId: normalizeId("Product Id", element["Product Id"]),
          areaId: normalizeId("Area Id", element["Area Id"]),
          retailerId: normalizeId("Retailer Id", element["Retailer Id"]),
        };

        const { productId, areaId, retailerId } = ids;

        const triplet = `${productId}-${areaId}-${retailerId}`;
        const found = scenariosEstimationsMap.get(triplet);
        if (!found) {
          dataError.data = `[Row ${line}] The following Product-Retailer-Area from .csv file is not present in the scenario. Please, remove it`;
          dataError.description = JSON.stringify(element);
          throw dataError;
        }
        if (checkTradePromotionAnnual()) {
          // Check that Date have the correct format
          const dateFormat = moment(element.Date, "YYYY-MM-DD", true).isValid();
          // Check that Date is not duplicated
          const estimationKey = `${element.Date}-${element["Product Id"]}-${element["Area Id"]}-${element["Retailer Id"]}`;
          if (estimationKey in checkDuplicatedKeys) {
            dataError.data = `[Row ${line}] The following Date from .csv file is duplicated. Please, change it`;
            dataError.description = JSON.stringify(element);
            throw dataError;
          } else {
            checkDuplicatedKeys[estimationKey] = null;
          }

          // Check that Date is within the range
          const arrayValidDates = [];
          let currentDate = moment(cycleData.initial_date)
            .add(14, "days")
            .format("YYYY-MM-DD");
          for (let i = 0; i <= 11; i += 1) {
            if (Date.parse(currentDate) < Date.parse(cycleData.final_date)) {
              arrayValidDates.push(currentDate);
              currentDate = moment(currentDate)
                .add(1, "M")
                .format("YYYY-MM-DD");
            }
          }
          const dateRange = _.find(arrayValidDates, (estimation) => {
            return estimation === element.Date;
          });

          if (!dateFormat) {
            dataError.data = `The following date: ${element.Date} found in row [${line}] from .csv file does not have the correct format:`;
            dataError.description = (
              <strong>{`The format of date '${element.Date}' is not supported. Please change it to YYYY-MM-DD. E.g. '2000-12-31'.`}</strong>
            );
            throw dataError;
          }

          if (!dateRange) {
            dataError.data = `[Row ${line}] The following Date from .csv file is out of range. Please, change it`;
            dataError.description = JSON.stringify(element);
            throw dataError;
          }
        }
        let elementEvent = {};
        if (checkDailyTradePromotions()) {
          elementEvent =
            element.Event === "TPR" ? { id: null, label: "TPR" } : {};
          _.map(catalogSlice.events, (event) => {
            if (
              (event.label === "Multibuy" && element.Event === "MB") ||
              event.label === element.Event
            ) {
              elementEvent = event;
            }
          });
          if (Object.keys(elementEvent).length === 0) {
            dataError.data = `[Row ${line}] The following Event from .csv file does not have the correct format. Please, change it`;
            dataError.description = JSON.stringify(element);
            throw dataError;
          }
          // set eventId here to don't recalculate in send iteration.
          dataJSON.data[index].eventId = elementEvent.id;

          // Check that Date have the correct format
          const dateFormat = moment(element.Date, "YYYY-MM-DD", true).isValid();
          const estimationKey = `${element.Date}-${element["Product Id"]}-${element["Area Id"]}-${element["Retailer Id"]}`;
          if (estimationKey in checkDuplicatedKeys) {
            dataError.data = `[Row ${line}] The following Date from .csv file is duplicated. Please, change it`;
            dataError.description = JSON.stringify(element);
            throw dataError;
          } else {
            checkDuplicatedKeys[estimationKey] = null;
          }

          // Check that Date is within the range
          const dateRange = moment(element.Date, "YYYY-MM-DD", true).isBetween(
            moment(cycleData.initial_date),
            moment(cycleData.final_date),
            "days",
            "[]"
          );

          if (!dateFormat) {
            dataError.data = `The following date: ${element.Date} found in row [${line}] from .csv file does not have the correct format:`;
            dataError.description = (
              <strong>{`The format of date '${element.Date}' is not supported. Please change it to YYYY-MM-DD. E.g. '2000-12-31'.`}</strong>
            );
            throw dataError;
          }

          if (!dateRange) {
            dataError.data = `[Row ${line}] The following Date from .csv file is out of range. Please, change it`;
            dataError.description = JSON.stringify(element);
            throw dataError;
          }
        }
        line += 1;
        switch (cycleType) {
          case "Pricing 2.0":
            formatDataJSON.push({
              product_id: element["Product Id"],
              retailer_id: element["Retailer Id"],
              area_id: element["Area Id"],
              price: element.Price,
              date: element.Date,
            });
            break;
          case "Daily Trade Promotions":
            formatDataJSON.push({
              product_id: element["Product Id"],
              retailer_id: element["Retailer Id"],
              area_id: element["Area Id"],
              price: element.Price,
              date: element.Date,
              event_id: elementEvent.id,
            });
            break;
          default:
            formatDataJSON.push({
              product_id: element["Product Id"],
              retailer_id: element["Retailer Id"],
              area_id: element["Area Id"],
              price: element.Price,
            });
            break;
        }
      });

      const dataForUpdate = {
        scenario_id: scenarioId,
        get_price_from_promotional_price_flag: true,
        prices_by_triplet: formatDataJSON,
      };
      dialogClose();
      try {
        const tasks = [];
        const chunkSize = 50000;
        const numberOfChunks = Math.ceil(
          dataForUpdate.prices_by_triplet.length / chunkSize
        );
        if (numberOfChunks > 1) {
          for (let i = 0; i < numberOfChunks; i += 1) {
            tasks.push(
              updatePriceScenario({
                scenario_id: dataForUpdate.scenario_id,
                get_price_from_promotional_price_flag: dataForUpdate.get_price_from_promotional_price_flag,
                prices_by_triplet: dataForUpdate.prices_by_triplet.slice(
                  i * chunkSize,
                  (i + 1) * chunkSize
                ),
              })
            );
          }
        } else {
          tasks.push(updatePriceScenario(dataForUpdate));
        }
        const tasksResponses = await Promise.all(tasks);
        const lastTask = tasksResponses.at(-1);
        const enqueueTask = async () => {
          setArePendingTasks(true);

          snackbarKey = enqueueLoadingSnackbar(
            <TaskProgressSnackbar
              taskId={lastTask.id}
              size={40}
              className={classes.circularProgress}
            />
          );
          try {
            // First we check the last task associated to this process when this task is marked at finished whether fail or success we will check the rest
            await getStatus(lastTask.id, async (status) => {
              switch (status.task_status) {
                case "FAILURE":
                  enqueueErrorSnackbar(snackbarKey);
                  break;
                case "SUCCESS": {
                  const taskStatus = [];
                  // Now we need to check all the status for the rest of the async tasks except the last one because is the one that we are cheking during this process
                  for (let i = 0; i < numberOfChunks - 1; i += 1) {
                    taskStatus.push(
                      getStatusWithoutPolling(tasksResponses.at(i).id)
                    );
                  }
                  let statusResponses = await Promise.all(taskStatus);
                  while (
                    _.every(statusResponses, (task) => {
                      const finishedStatus = ["SUCCESS", "FAILURE"];
                      return finishedStatus.includes(task.task_status);
                    }) === false
                  ) {
                    const checkTaskStatus = [];
                    await sleep(2000);
                    for (let i = 0; i < numberOfChunks - 1; i += 1) {
                      checkTaskStatus.push(
                        getStatusWithoutPolling(tasksResponses.at(i).id)
                      );
                    }
                    statusResponses = await Promise.all(checkTaskStatus);
                  }
                  if (_.every(statusResponses, { task_status: "SUCCESS" })) {
                    enqueueSuccessSnackbar(() => {
                      const scenarioPath = getPathnameByCycletype(
                        cycleType,
                        url
                      );
                      history.push(scenarioPath);
                      dispatch(changeSelectedScenarioAsyncAction(scenarioId));
                    }, snackbarKey);
                    if (
                      scenariosSlice.selectedScenario.scenario_id === scenarioId
                    ) {
                      dispatch(changeSelectedScenarioAsyncAction(scenarioId));
                    }
                    dispatch(
                      addScenarioTotalsAsyncAction({
                        filters: {
                          scenario_type_id: [1, 3],
                        },
                        expand: ["scenario", "scenario.cycle"],
                      })
                    );
                    dispatch(removeTask(lastTask.id));
                    setArePendingTasks(false);
                  } else {
                    enqueueErrorSnackbar(snackbarKey);
                  }
                  return;
                }
                case "PENDING":
                  return;
                default:
                  dispatch(
                    setTask({
                      id: lastTask.id,
                      progress:
                        (status.task_info?.step * 100) /
                        status.task_info?.total_steps,
                    })
                  );
              }
            });
          } catch (e) {
            if (e instanceof PollingTimeoutError) {
              enqueueTimeoutSnackbar(enqueueTask, snackbarKey);
            } else throw e;
          }
        };
        await enqueueTask();
      } catch (e) {
        // Log the error somewhere
        enqueueErrorSnackbar(snackbarKey);
      }
      setDataError("");
      setDataDescriptionError("Successful validation");
    } catch (error) {
      setDataError(error.data);
      setDataDescriptionError(error.description);
    }
    setIsLoading(false);
  };

  const handleClickImportCSV = (e) => {
    importCSV(e);
    trackCSVButton();
  };

  const loadingCircle = () => (
    <CircularProgress size={24} className={classes.circularProgress} />
  );

  const handleDownloadTemplate = (e) => {
    e.stopPropagation();
    const arrayRows = [];
    if (
      scenariosSlice.totalsByScenarioId[scenarioId].delivery_id !==
      scenariosSlice.selectedScenario.delivery_id
    ) {
      _.forEach(scenarioEstimations, (row) => {
        arrayRows.push({
          "Product Id": row.product_id,
          "Product UPC":
            catalogForDataload.products[row.product_id].product_code,
          Product: catalogForDataload.products[row.product_id].label,
          Retailer: catalogForDataload.retailers[row.retailer_id].label,
          "Retailer Id": row.retailer_id,
          Area: catalogForDataload.areas[row.area_id].label,
          "Area Id": row.area_id,
          Line: catalogForDataload.products[row.product_id].line.label,
          Category:
            catalogForDataload.products[row.product_id].line.categories[0]
              .label,
          Price: row.price,
        });
      });
    } else {
      _.forEach(scenarioEstimations, (row) => {
        arrayRows.push({
          "Product Id": row.product_id,
          "Product UPC": !row.product?.product_code
            ? catalogSlice.products[row.product_id].product_code
            : row.product.product_code,
          Product: !row.product?.label
            ? catalogSlice.products[row.product_id].label
            : row.product.label,
          Retailer: !row.retailer?.label
            ? retailersSlice[row.retailer_id].label
            : row.retailer.label,
          "Retailer Id": row.retailer_id,
          Area: !row.area?.label
            ? areaSlice[row.area_id].label
            : row.area.label,
          "Area Id": row.area_id,
          Line: !row.product?.line.label
            ? catalogSlice.products[row.product_id].line.label
            : row.product.line.label,
          Category: !row.product?.line.categories[0].label
            ? catalogSlice.products[row.product_id].line.categories[0].label
            : row.product.line.categories[0].label,
          Price: row.price,
        });
      });
    }
    try {
      enqueueSnackbar(`Download for ${scenarioName} is ready!`, {
        variant: "success",
      });

      const csvData = jsonToCSV(arrayRows);

      downloadBlob(csvData, `${scenarioName}_template`, "csv");
    } catch {
      enqueueSnackbar(
        `Error when downloading ${scenarioName}. Try again shortly`,
        {
          variant: "error",
        }
      );
    } finally {
      const snackbarKey = enqueueSnackbar(
        `${scenarioName} is getting ready for download`,
        {
          persist: true,
          action: loadingCircle,
        }
      );

      closeSnackbar(snackbarKey);
    }
  };

  return (
    <CardComponent
      withoutPadding
      body={
        <Box className={classes.root}>
          <div className={classes.inputContainer}>
            <div className={classes.startText}>
              <Typography className={classes.fileName}>
                {!isSelectedCsv ? fileNameValue : "select a .csv file"}
              </Typography>
            </div>
            <input
              ref={fileInput}
              type="file"
              accept=".csv"
              disableUnderline
              style={{ display: "none" }}
              onChange={(e) => {
                setIsSelectedCsv(false);
                setFileNameValue(e.target.files[0]?.name);
                setCsvFile(e.target.files[0]);
              }}
            />
            <div className={classes.endButtonInput}>
              <StyledButtonBrowse
                variant="contained"
                disableRipple
                onClick={() => fileInput.current.click()}
                style={{
                  textTransform: "none",
                  fontSize: "15px",
                  paddingTop: "3px",
                  paddingBottom: "3px",
                  backgroundColor: "white",
                }}
              >
                Browse
              </StyledButtonBrowse>
            </div>
          </div>
          <div className={classes.buttonContainer}>
            <div className={classes.startButton}>
              {!checkTradePromotionAnnual() && !checkDailyTradePromotions() ? (
                <StyledButton
                  autoFocus
                  variant="outlined"
                  disableRipple
                  disabled={!scenarioEstimations}
                  onClick={(e) => handleDownloadTemplate(e)}
                  style={{
                    textTransform: "none",
                    fontSize: "15px",
                    color: "black",
                    backgroundColor: "white",
                    paddingTop: "3px",
                    paddingBottom: "3px",
                  }}
                >
                  {!scenarioEstimations ? (
                    <ScaleLoader
                      loading
                      data-testid="spinner"
                      height={15}
                      color={primaryColor}
                      spinnerParent
                    />
                  ) : (
                    "Download template"
                  )}
                </StyledButton>
              ) : (
                <ButtonWithExportTemplate />
              )}
            </div>
            <div className={classes.endButton}>
              <StyledButtonImport
                autoFocus
                variant="contained"
                color="primary"
                disableRipple
                className={`${classes.disabledButton} ${classes.spinnerParent}`}
                disabled={isSelectedCsv}
                style={{
                  textTransform: "none",
                  fontSize: "17px",
                  paddingTop: "3px",
                  paddingBottom: "3px",
                  width: "115px",
                  height: "36px",
                }}
                onClick={(e) => handleClickImportCSV(e)}
              >
                {isLoading ? (
                  <ScaleLoader
                    loading
                    data-testid="spinner"
                    height={15}
                    color="white"
                    spinnerParent
                  />
                ) : (
                  "Import"
                )}
              </StyledButtonImport>
            </div>
          </div>
        </Box>
      }
    />
  );
};

export default ImportScenarioCard;
